import * as React from 'react';
export const IcSunnyPartlyCloudy = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.4 5.92c.21.51.8.75 1.31.54.51-.21.75-.8.54-1.31L9.48 3.3c-.21-.51-.8-.75-1.31-.54-.51.21-.75.8-.54 1.31l.77 1.85zm-3.25 7.84l-1.85.77c-.51.21-.75.8-.54 1.31.21.51.8.75 1.31.54l1.85-.77c.51-.21.75-.8.54-1.31-.21-.51-.8-.75-1.31-.54zm13.7-3.51l1.85-.77c.51-.21.75-.8.54-1.31-.21-.51-.8-.75-1.31-.54l-1.85.77c-.51.21-.75.8-.54 1.31.21.51.8.75 1.31.54zM5.92 8.4l-1.85-.77c-.51-.21-1.1.03-1.31.54-.21.51.03 1.1.54 1.31l1.85.77c.51.21 1.1-.03 1.31-.54.21-.51-.03-1.1-.54-1.31zm8.38-1.94c.51.21 1.1-.03 1.31-.54l.77-1.85c.21-.51-.03-1.1-.54-1.31-.51-.21-1.1.03-1.31.54l-.77 1.85c-.21.51.03 1.1.54 1.31zm-2.77 6.56A5.99 5.99 0 0116 11c.31 0 .61.02.91.07A4.993 4.993 0 0012 7c-2.76 0-5 2.24-5 5 0 1.13.39 2.16 1.02 2.99a4.967 4.967 0 013.51-1.97zm8.38 3.13A4.001 4.001 0 0016 13c-1.5 0-2.79.83-3.47 2.05A2.996 2.996 0 009 18c-1.1 0-2 .9-2 2s.9 2 2 2h10a2.996 2.996 0 00.91-5.85z'
      fill='currentColor'
    />
  </svg>
);
